export const taxRoutes = {
    homepage: '/taxinsights'
}

export const isHarvesterWindowClosedForThisFY = true;